import { render } from "./OwnerCard.vue?vue&type=template&id=9e2f8d50&scoped=true&bindings={\"team\":\"props\"}"
import script from "./OwnerCard.vue?vue&type=script&lang=ts"
export * from "./OwnerCard.vue?vue&type=script&lang=ts"

import "./OwnerCard.vue?vue&type=style&index=0&id=9e2f8d50&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9e2f8d50"

export default script